
export type TweetCreateRequestMediaItemType = typeof TweetCreateRequestMediaItemType[keyof typeof TweetCreateRequestMediaItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetCreateRequestMediaItemType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
} as const;
